import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionLaughIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 28 28" })}>
    <rect fill="#A5417D" height="28" rx="14" width="28" />
    <path
      clipRule="evenodd"
      d="M14 3.5C8.201 3.5 3.5 8.201 3.5 14C3.5 19.799 8.201 24.5 14 24.5C19.7983 24.5 24.5 19.799 24.5 14C24.5 8.201 19.7983 3.5 14 3.5Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.0293 21.3837C8.97426 21.3837 7.02051 18.7175 7.02051 17.3637C7.02051 16.9932 7.32051 16.6932 7.69101 16.6932H20.3675C20.738 16.6932 21.038 16.9932 21.038 17.3637C21.038 18.7175 19.0843 21.3837 14.0293 21.3837Z"
      fill="#8D386B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.98784 10.1653C8.66459 9.97851 8.55359 9.56451 8.74034 9.24126C8.92709 8.91801 9.34109 8.80701 9.66434 8.99376L12.3591 10.5493C12.5496 10.6595 12.6553 10.8493 12.6808 11.0518C12.6868 11.0863 12.6876 11.1185 12.6883 11.153C12.6876 11.1868 12.6868 11.2198 12.6808 11.2535C12.6553 11.456 12.5496 11.6465 12.3591 11.756L9.66434 13.3123C9.34109 13.499 8.92709 13.388 8.74034 13.0648C8.55359 12.7408 8.66459 12.3275 8.98784 12.1408L10.6986 11.153L8.98784 10.1653Z"
      fill="#8D386B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.0959 11.0518C15.1214 10.8493 15.2271 10.6595 15.4176 10.5493L18.1124 8.99376C18.4364 8.80701 18.8496 8.91801 19.0364 9.24126C19.2231 9.56451 19.1129 9.97851 18.7889 10.1653L17.0781 11.153L18.7889 12.1408C19.1129 12.3275 19.2231 12.7408 19.0364 13.0648C18.8496 13.388 18.4364 13.499 18.1124 13.3123L15.4176 11.756C15.2271 11.6465 15.1214 11.456 15.0959 11.2535C15.0899 11.2198 15.0899 11.1868 15.0891 11.153C15.0899 11.1185 15.0899 11.0863 15.0959 11.0518Z"
      fill="#8D386B"
      fillRule="evenodd"
    />
  </svg>
);
